import React from 'react';
import Link from '@nubank/nuds-web/components/Link/Link';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Icon from '@nubank/nuds-web/components/Icon/Icon';

import websitePage from 'hoc/websitePage/websitePage';
import Section from 'components/structure/Section';
import OldPageSectionHeading from 'components/structure/OldPageSectionHeading';
import Block from 'components/structure/Block/Block';
import { paddingBuilder } from 'styles/themeUtils';

import { OmbudsmanContactList } from './styles/OmbudsmanChannel';
import { FollowNubank } from './styles/FollowNubank';
import {
  Channel,
  Channels,
  Divider,
  StyledTypographyChannelHeading,
  StyledTypographyChannelSubtitle,
} from './styles/Channel';
import { SocialLinks } from './styles/SocialLinks';

const channels = [
  {
    channelName: 'CONTACT.CHANNELS.EMAIL.NAME',
    subtitle: 'CONTACT.CHANNELS.EMAIL.SUBTITLE',
    link: 'CONTACT.CHANNELS.EMAIL.LINK',
    href: 'mailto:meajuda@nubank.com.br',
  },
  {
    channelName: 'CONTACT.CHANNELS.PHONE.NAME',
    subtitle: 'CONTACT.CHANNELS.PHONE.SUBTITLE',
    link: 'CONTACT.CHANNELS.PHONE.LINK',
    href: 'tel:08006086236',
  },
  {
    channelName: 'CONTACT.CHANNELS.CHAT.NAME',
    subtitle: 'CONTACT.CHANNELS.CHAT.SUBTITLE',
    link: 'CONTACT.CHANNELS.CHAT.LINK',
    href: 'nuapp://chat',
  },
];

function Contact() {
  return (
    <>
      <OldPageSectionHeading intlKey="CONTACT.TITLE" />

      <Section minHeight="auto">
        <Block
          blockWidth="100%"
          padding={{
            default: paddingBuilder.top(2),
          }}
        >
          <Channels>
            {channels.map(channel => (
              <Channel key={`channel-${channel.channelName}`}>
                <StyledTypographyChannelHeading
                  variant="subtitle"
                  intlKey={channel.channelName}
                  gutterBottom={1}
                />
                <StyledTypographyChannelSubtitle
                  gutterBottom={0.5}
                  intlKey={channel.subtitle}
                />
                <Link
                  intlKey={channel.link}
                  color="primary"
                  href={channel.href}
                  variant="action"
                />
              </Channel>
            ))}
          </Channels>

          <Divider />

          <FollowNubank>
            <Typography
              variant="subtitle"
              intlKey="CONTACT.FOLLOW.TITLE"
              gutterBottom={2}
            />

            <StyledTypographyChannelSubtitle
              gutterBottom={2}
              intlKey="CONTACT.FOLLOW.SUBTITLE"
              intlValues={{
                br: <br />,
                link: (
                  <Link
                    intlKey="CONTACT.FOLLOW.SUBTITLE.LINK"
                    color="primary"
                    typographyProps={{
                      variant: 'paragraph1',
                    }}
                    href="https://comunidade.nubank.com.br/?utm_content=www_contact"
                  />
                ),
              }}
            />

            <SocialLinks>
              <li>
                <Link
                  color="black"
                  href="https://www.facebook.com/nubank"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon title="Facebook Icon" name="facebook" />
                </Link>
              </li>

              <li>
                <Link
                  color="black"
                  href="https://www.instagram.com/nubank/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon title="Instagram Icon" name="instagram" />
                </Link>
              </li>

              <li>
                <Link
                  color="black"
                  href="https://www.youtube.com/nubank"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon title="YouTube Icon" name="youtube" />
                </Link>
              </li>

              <li>
                <Link
                  color="black"
                  href="https://www.linkedin.com/company/nubank"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon title="LinkedIn Icon" name="linkedin" />
                </Link>
              </li>

              <li>
                <Link
                  color="black"
                  href="https://www.twitter.com/nubank"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon title="Twitter Icon" name="twitter" />
                </Link>
              </li>
            </SocialLinks>
          </FollowNubank>

          <Divider />

          <Typography
            variant="subtitle"
            intlKey="CONTACT.PRESS.TITLE"
            gutterBottom={2}
          />

          <Typography
            gutterBottom={2}
            intlKey="CONTACT.PRESS.SUBTITLE"
            intlValues={{
              link: (
                <Link
                  intlKey="CONTACT.PRESS.SUBTITLE_LINK"
                  color="primary"
                  href="/imprensa"
                  typographyProps={{
                    variant: 'paragraph1',
                  }}
                />
              ),
            }}
          />

          <Link color="primary" href="mailto:press@nu.bank" variant="action">
            press@nu.bank
          </Link>

          <Divider />

          <Typography
            variant="subtitle"
            intlKey="CONTACT.OMBUDSMAN.TITLE"
            gutterBottom={2}
          />
          <Typography
            intlKey="CONTACT.OMBUDSMAN.SUBTITLE"
            intlValues={{
              br: <br />,
            }}
            gutterBottom={1}
          />

          <OmbudsmanContactList>
            <li>
              <Link
                color="primary"
                href="tel:08008870463"
                variant="action"
              >
                0800 887 0463
              </Link>
            </li>
            <li>
              <Link
                color="primary"
                href="mailto:ouvidoria@nubank.com.br"
                variant="action"
              >
                ouvidoria@nubank.com.br
              </Link>
            </li>
          </OmbudsmanContactList>
          <Typography
            intlKey="CONTACT.OMBUDSMAN.OFFICE_HOURS"
            intlValues={{
              br: <br />,
            }}
          />

          <Divider />

          <Typography
            intlKey="CONTACT.PARTNERSHIP.TITLE"
            variant="subtitle"
            gutterBottom={2}
          />

          <Typography
            intlKey="CONTACT.PARTNERSHIP.SUBTITLE"
            intlValues={{
              br: <br />,
              a: (...link) => (
                <Link
                  color="primary"
                  href={`mailto:${link}`}
                  variant="action"
                >
                  {link}
                </Link>
              ),
            }}
          />
        </Block>
      </Section>
    </>
  );
}

export default websitePage({
  routeKey: 'CONTACT',
})(Contact);
